"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var pin_container_component_1 = __importDefault(require("./pin-container.component"));
var point_of_interest_pin_component_1 = __importDefault(require("./point-of-interest-pin.component"));
var MapPointOfInterest = function (_a) {
    var location = _a.location;
    return (react_1.default.createElement(pin_container_component_1.default, { location: location },
        react_1.default.createElement(point_of_interest_pin_component_1.default, null)));
};
MapPointOfInterest.displayName = 'MapPointOfInterest';
exports.default = MapPointOfInterest;
//# sourceMappingURL=map-point-of-interest.component.js.map